import React, { useEffect, useRef, useState } from 'react'
import Base64Downloader from 'common-base64-downloader-react';
import { Dialog } from 'primereact/dialog'
import { Button } from 'primereact/button';
import apis from '../../api';
// import emailjs from '@emailjs/browser';

const TermsModal = (props) => {


    const [textLegalTerms, setTextLegalTerms] = useState([]);
    const [fileTerms, setFileTerms] = useState("");
    const [filePolicies, setFilePolicies] = useState("");
    const [nameTerms, setNameTerms] = useState("");
    const [namePolicies, setNamePolicies] = useState("");
    const { accept, cancel, isOpenTerms, setIsOpenTerms, loading, setLoading } = props

    const [loading1, setLoading1] = useState(false);
    const [loading2, setLoading2] = useState(false);

    useEffect(() => {
        /*Se encarga de mostar el spinner de la vista si no se ha clickeado el botón*/
        const getTerms = async () => {
            await apis.postLegalTerms({}).then(res => {
                let doc1 = "data:application/pdf;base64," + res.data.PDF_POLICIES.DATA
                let doc2 = "data:application/pdf;base64," + res.data.PDF_TERMS.DATA
                setFileTerms(doc2)
                setFilePolicies(doc1)
                setNameTerms(res.data.PDF_TERMS.NAME)
                setNamePolicies(res.data.PDF_POLICIES.NAME)
                var textLegal = res.data.TXT.split("|");
                setTextLegalTerms(textLegal);
                console.log(textLegal)
            }).catch(err => {
                console.log(err)
            })
        }
        getTerms()
    }, []);

    const termsFooter = () => {
        return (
            <div className='flex flex-row justify-content-between pt-2'>
                <div className='flex flex-row -mb-2 -ml-3'>
                    <Base64Downloader style={{ border: "0px", background: "transparent" }} base64={fileTerms} downloadName={nameTerms} onDownloadSuccess={() => { setLoading1(false) }}>
                        <Button label="Terminos y condiciones" icon="pi pi-file-pdf" onClick={() => setLoading1(true)} className="p-button-outlined p-button-sm" />
                    </Base64Downloader>
                    <Base64Downloader style={{ border: "0px", background: "transparent" }} base64={filePolicies} downloadName={namePolicies} onDownloadSuccess={() => { setLoading2(false) }}>
                        <Button label="Política de datos" icon="pi pi-file-pdf" onClick={() => setLoading2(true)} className="p-button-outlined p-button-sm" />
                    </Base64Downloader>
                </div>
                <div className='flex flex-row -mb-2 -mr-3 ml-6'>
                    <Button label="No Acepto" icon="pi pi-times" onClick={() => cancel()} className="p-button-text ml-4" />
                    <Button label="Acepto" loading={loading} icon="pi pi-check" onClick={() => { accept() }} className="p-button-text" />
                </div>
            </div>
        );
    }

    return (
        <div>
            <Dialog header="Terminos y condiciones" visible={isOpenTerms} style={{ width: '70vw' }} footer={termsFooter} onHide={() => { cancel() }}>
                {
                    textLegalTerms.map((item, index) => {
                        return <div key={index}> <p >{item}</p> <br /></div>
                    })
                }
            </Dialog>
        </div>
    )
}

export default TermsModal;